import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { Provider } from "@Front-end/seed/models/provider";
import { SearchResult } from "@Front-end/seed/models/search";
import {
    Observable,
    throwError,
} from "rxjs";
import {
    catchError,
    map,
} from "rxjs/operators";
import { sportBrandId } from "../../constants/sporting.constants";

export const sportbookProviderInterceptor: HttpInterceptorFn = (request, next) => {
    const providersUrl: string = "game/brand/list";
    const searchUrl: string = "/search";
    const brandId: number = sportBrandId;

    return next(request).pipe(
        map((event) => {
            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { result: unknown })?.result
                && request.url.includes(providersUrl)
            ) {
                const updatedBrands: Provider[] = (<Provider[]> (event.body as { result: unknown }).result)
                    .filter((item: Provider) => item.brand_id !== brandId);
                event = event.clone({ body: { ...(event.body as { result: unknown }), result: updatedBrands } });
            }

            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { result: unknown })?.result
                && request.url.includes(searchUrl)
            ) {
                const updatedBrands: Provider[] = (<Provider[]> (event.body as {
                    result: { brands: { result: unknown } }
                }).result.brands.result)
                    .filter((item: Provider) => item.brand_id !== brandId);
                const updatedResult: SearchResult = {
                    // @ts-ignore
                    ...event.body.result,
                    brands: {
                        // @ts-ignore
                        ...event.body.result.brands,
                        result: updatedBrands,
                    },
                };
                event = event.clone({
                    // @ts-ignore
                    body: { ...event.body, result: updatedResult },
                });
            }

            return event;
        }),
        catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
    );
};
